import React from "react";
import Candle from "../../candle/Candle";
import { EDGE } from "../../core/edgeTokens";
import { priceDomain } from "../../candle/candleModel";
import { measureText } from "../../core/measureText";
import { CANDLES, COPY } from "./config";
import Sentences from "../../core/Sentences";

// Beat 3 no-wick teaching visual (everyone sees it). Two small, non-interactive
// candles showing that one body edge can stand for two values when a wick is
// absent: the top edge is both Close and High, the bottom edge both Open and Low.
export default function NoWickDiagram() {
  return (
    <div className="mt-4 rounded-xl border border-gray-200 px-4 py-3">
      <div className="flex justify-center gap-6">
        <Mini ohlc={CANDLES.noUpperWick} edge="top" label="Close · High" />
        <Mini ohlc={CANDLES.noLowerWick} edge="bottom" label="Open · Low" />
      </div>
      <Sentences text={COPY.noWick} className="mt-2 text-sm text-bodyInk" />
    </div>
  );
}

function Mini({ ohlc, edge, label }) {
  // Wide enough for the label in the rendered font, so it is never clipped.
  const W = Math.max(150, Math.ceil(72 + measureText(label, 11, 600) + 4));
  const H = 120;
  const [d0, d1] = priceDomain(ohlc);
  const scale = {
    x: (d) => 40 + d * 16,
    y: (p) => 110 - ((p - d0) / (d1 - d0)) * 100,
  };
  const edgeY = scale.y(edge === "top" ? Math.max(ohlc.open, ohlc.close) : Math.min(ohlc.open, ohlc.close));
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ "--s": W / 150 }} className="w-[calc(130px*var(--s))] md:w-[calc(150px*var(--s))] h-auto" aria-hidden="true">
      <Candle ohlc={ohlc} scale={scale} bodyHalf={0.5} />
      {/* Same placement rule as every other diamond: beside the body, its left
          point touching the body edge it marks (body is 8 wide each side of 40),
          extending right into clear space. */}
      <polygon points={`48,${edgeY} 54,${edgeY - 6} 60,${edgeY} 54,${edgeY + 6}`} fill={EDGE.gold} />
      <line x1={61} x2={70} y1={edgeY} y2={edgeY} stroke={EDGE.line} strokeWidth={1.2} strokeDasharray="2 2" />
      <text x={72} y={edgeY + 4} fontSize={11} fontWeight={600} fill={EDGE.ink}>
        {label}
      </text>
    </svg>
  );
}
